import Vue from 'vue';

Vue.directive('show-hide-elems', {

    // bind(el, binding, vnode) {
    // 	// binding pega o valor passado por parametro na diretiva (no elemento que é chamado)
    // 	let url = document.location.pathname;

    // 	let timer = 0;

    // 	var fnTimer = function() {
    // 		timer = setInterval(function(){
    // 			url = document.location.pathname;
    // 			if(url != '/') {
    // 				clearInterval(timer);
    // 				return;
    // 			};
    // 			el.style.display = 'none';
    // 		}, 5000);
    // 	}

    // 	document.addEventListener('mousemove', function() {
    // 		clearInterval(timer);
    // 		fnTimer();
    // 		if(el.style.display == 'block') return;
    // 		el.style.display = 'block';
    // 	});
    // }

});


// WEBPACK FOOTER //
// ./src/directives/Transform.js